export const readURL = (file: File) => {
  return new Promise<string>((res, rej) => {
    const reader = new FileReader();
    reader.onload = (e) => res(String(e?.target?.result));
    reader.onerror = (e) => rej(e);
    reader.readAsDataURL(file);
  });
};
